/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  CreateFaqMutationRequest,
  CreateFaqMutationResponse,
} from "../types/CreateFaq.ts"

export const createFaqMutationKey = () =>
  [{ url: "/v1/faq/create-faq" }] as const

export type CreateFaqMutationKey = ReturnType<typeof createFaqMutationKey>

/**
 * @summary Create a new FAQ entry
 * {@link /v1/faq/create-faq}
 */
export async function createFaq(
  data: CreateFaqMutationRequest,
  config: Partial<RequestConfig<CreateFaqMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateFaqMutationResponse,
    ResponseErrorConfig<Error>,
    CreateFaqMutationRequest
  >({
    method: "POST",
    url: `/v1/faq/create-faq`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createFaqMutationOptions(
  config: Partial<RequestConfig<CreateFaqMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = createFaqMutationKey()
  return mutationOptions<
    ResponseConfig<CreateFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateFaqMutationRequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createFaq(data, config)
    },
  })
}

/**
 * @summary Create a new FAQ entry
 * {@link /v1/faq/create-faq}
 */
export function useCreateFaq<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateFaqMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateFaqMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateFaqMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createFaqMutationKey()

  const baseOptions = createFaqMutationOptions(config) as UseMutationOptions<
    ResponseConfig<CreateFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateFaqMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateFaqMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateFaqMutationRequest },
    TContext
  >
}
